/**
 * @generated SignedSource<<9a88e91d2d2d64944f3cfa5292d4113b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type providerQueryDeleteMutation$variables = {
  id: string;
};
export type providerQueryDeleteMutation$data = {
  readonly deleteApiKey: {
    readonly autoConfirmOrders: boolean;
    readonly clientId: number;
    readonly descriptionKey: string | null;
    readonly id: string;
    readonly providerId: number;
    readonly secretKey: string | null;
    readonly statusId: number;
  } | null;
};
export type providerQueryDeleteMutation = {
  response: providerQueryDeleteMutation$data;
  variables: providerQueryDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "ProviderApiKeyDto",
    "kind": "LinkedField",
    "name": "deleteApiKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "autoConfirmOrders",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "descriptionKey",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "providerId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "secretKey",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "providerQueryDeleteMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "providerQueryDeleteMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "3f35587031657903e5c4aa4922722b76",
    "id": null,
    "metadata": {},
    "name": "providerQueryDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation providerQueryDeleteMutation(\n  $id: ID!\n) {\n  deleteApiKey(id: $id) {\n    clientId\n    autoConfirmOrders\n    descriptionKey\n    id\n    providerId\n    secretKey\n    statusId\n  }\n}\n"
  }
};
})();

(node as any).hash = "83c3335bf99761e92d19a0c239e30e8f";

export default node;
